import isValueEmpty from '../../isValueEmpty';

export const errorMessage = __('The minimum allowed is %{minimum}');

export const validateMinimum = (value, minimum) => {
  let error;

  if (isValueEmpty(value)) {
    return error;
  }

  if (Number(value) < Number(minimum)) {
    error = errorMessage.i__({
      minimum,
    });
  }

  return error;
};
